<footer class="app-footer">
    @let footerStyles = $safeNavigationMigration(footer()?.styles);
    @if (footerStyles) {
        <div [appCmsStyles]="footerStyles"></div>
    }

    <div class="tg-container app-footer__inner">
        @let copyright = copyrightBlock();

        <div class="app-footer__columns">
            @for (block of linksList(); track block.id) {
                <app-footer-links-column [block]="block" />
            }

            @let contact = contactInfo();
            @let socials = socialItems();
            @if (contact || socials.length) {
                <div class="app-footer__contact">
                    @if (contact) {
                        <app-footer-contact [contact]="contact" />
                    }
                    @if (socials.length) {
                        <app-footer-socials [socials]="socials" />
                    }
                </div>
            }
        </div>

        @if (copyright) {
            <app-footer-copyright [copyright]="copyright" />
        }
    </div>
</footer>
